export default __webpack_public_path__ + "static/media/heroKits.662d4445.jpg";